// extracted by mini-css-extract-plugin
module.exports = {"flexWrapper":"src_flexWrapper__3IfKK"};